
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-story/in-the-news",
      function () {
        return require("private-next-pages/our-story/in-the-news.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-story/in-the-news"])
      });
    }
  